
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/trailmap",
      function () {
        return require("private-next-pages/[region]/[resort]/trailmap.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/trailmap"])
      });
    }
  